import { Module } from 'vuex'
import { RootState } from '@/Infrastructure/Store/RootState'
import { ProcedureState } from './ProcedureState'
import { getters } from './getters'
import { mutations } from './mutations'
import { actions } from './actions'

export const state: ProcedureState = {
  currentProcedure: undefined,
  resultasBatches: [],
  riscoBatches: []
}

const namespaced = true

export const procedure: Module<ProcedureState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
